import { message } from 'antd'
import { URL_ENDPOINT_LIST_ROLE } from './constants/config.list-role'
import axiosClient from '../../utils/custom-fetch'
import { MetadataType } from '../../utils/metadata.types'
import {
  BodyUpdateListRoleIdWithInputInput,
  CheckRoleInput,
  CreateListRoleInput,
  DetailListRoleInput,
  ListListRoleInput,
  ListRoleEntity,
} from '../../server-api-hrm.type'

const appEndpoint = URL_ENDPOINT_LIST_ROLE

export const getListListRole = async (
  token?: string,
  body?: ListListRoleInput
) => {
  if (!token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<{
      metadata: MetadataType
      data: ListRoleEntity[]
    }>(`${appEndpoint}/list/all`, body)
  } catch {
    message.error('Tải dữ liệu thất bại')
  }

  return null
}

export const getDetailListRole = async (
  token?: string,
  body?: DetailListRoleInput
) => {
  if (!body || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<ListRoleEntity>(
      `${appEndpoint}/detail`,
      body
    )
  } catch {
    message.error('Tải dữ liệu thất bại')
  }

  return null
}

export const addListRole = async (
  token?: string,
  body?: CreateListRoleInput
) => {
  if (!body || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<ListRoleEntity>(
      `${appEndpoint}/add`,
      body
    )
  } catch {
    message.error('Hành động thất bại')
  }

  return null
}

export const updateListRole = async (
  token?: string,
  body?: BodyUpdateListRoleIdWithInputInput
) => {
  if (!body || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<ListRoleEntity>(
      `${appEndpoint}/update`,
      body
    )
  } catch {
    message.error('Hành động thất bại')
  }

  return null
}

export const deleteListRole = async (
  token?: string,
  body?: DetailListRoleInput
) => {
  if (!body || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<ListRoleEntity>(
      `${appEndpoint}/delete`,
      body
    )
  } catch {
    message.error('Hành động thất bại')
  }

  return null
}

export const checkRole = async (token?: string, body?: CheckRoleInput) => {
  if (!body || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<boolean>(
      `${appEndpoint}/check-role`,
      body
    )
  } catch {
    message.error('Tải dữ liệu thất bại')
  }

  return null
}
